import "./_style.scss";
import { Box, Link } from "@mui/material";
import { infoManual, itemList, radioPropsList, urlList } from "./parts";
import { TkRadioGroup } from "../../components/atoms/TkRadioGroup";
import TkBackButton from "../../components/molecules/TkBackButton";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import React from "react";
import TkConfirmItem from "../../components/molecules/TkConfirmItem";
import { httpAPI_STA036 } from "./api/request";
import { OkOrNoFlug } from "../../assets/data/Constants";

/**
 * SCRC060119 退職情報　登録時の事前確認
 * @returns SCRC060119 退職情報　登録時の事前確認
 */

const SCRC060119 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { state, setState } = useContext(GlobalContext);
  const userType = state.authInfo?.userType;
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const isUserTypeDaikosha =
    userType === authorityUserType.userTypeNumber.DAIKOSHA;
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_32;
  const [isApiSuccessed, setIsApiSuccessed] = useState<boolean>(false);
  const [applyId, setApplyId] = useState<number>();
  const [selectedType, setSelectedType] = useState<string>();

  // 申請可否のチェック
  const onChangeRadio = (data: any) => {
    switch (!data) {
      case false:
        setSelectedType(data);
        break;
    }
  };

  // 初期化
  const handleInit = async () => {
    try {
      const staffNo = location.state?.staffNo ?? context?.staffNo;
      const res = await httpAPI_STA036({
        contractorNo: isUserTypeKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        facilityNo: location.state?.facilityNo ?? context?.facilityNo,
        staffNo,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setIsApiSuccessed(true);
        setApplyId(res.applyId);
        setFieldValue({
          check1:
            context?.check1 || (isUserTypeDaikosha ? OkOrNoFlug["はい"] : ""),
          check2: context?.check2,
          check3: context?.check3,
          check4: context?.check4,
          check5: context?.check5,
          check6: context?.check6,
        });
        setBusinessState({
          ...businessState,
          job_32: {
            ...context,
            facilityNo: res.facilityNo,
            staffNo,
          },
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [fieldValue, setFieldValue] = useState<any>({});

  const handleChange = (field: any) => (event: any) => {
    const newValue = {
      ...fieldValue,
      [field]: event,
    };
    setBusinessState({
      ...businessState,
      job_32: { ...context, ...newValue },
    });
    setFieldValue({ ...newValue });
  };

  return (
    <Box data-testid="SCRC060119PageForTest" className="SCRC060119">
      {isApiSuccessed && applyId && (
        <Box>
          <Box className="infoManual">{infoManual}</Box>
          <Box className="radioGroup">
            <TkRadioGroup
              radioPropsList={radioPropsList}
              onGetValue={onChangeRadio}
              wantToSetValue={selectedType}
            />
          </Box>
          {selectedType !== "1" && (
            <Box className="buttonBox">
              <TkBackButton />
            </Box>
          )}
        </Box>
      )}
      {isApiSuccessed && ((applyId && selectedType === "1") || !applyId) && (
        <Box data-testid="noApplyId">
          <TkInfoManual rule={"\\n"}>
            {labelids.labelid.LBLC060119_02}
          </TkInfoManual>

          {itemList.map((item, index) => (
            <React.Fragment key={index}>
              {item.keyword ? (
                <Box className="confirmItemLayout">
                  <TkConfirmItem
                    confimButtonContext={item.confimButtonContext}
                    functionButtonContext={item.funcButton}
                    radioPropsList={item.radioPropsList}
                    onChange={handleChange(item.keyword)}
                    onConfimButtonClicked={() =>
                      navigate(`${item.confirmNavi}`)
                    }
                    onFunctionButtonClicked={() => navigate(`${item.funcNavi}`)}
                    useCheckBox={item.useCheckBox}
                    checkboxContext={item.checkboxContext}
                    checked={fieldValue[item.keyword]}
                    isShowFunctionButton={
                      fieldValue[item.keyword] === OkOrNoFlug["いいえ"]
                    }
                    disabled={item.keyword === "check1" && isUserTypeDaikosha}
                  >
                    {item.title}
                  </TkConfirmItem>
                </Box>
              ) : (
                <Box className="lineTitleTextLabel">{item.lineTitle}</Box>
              )}
            </React.Fragment>
          ))}

          <Box className="references">
            <Box>（参考）</Box>
            {urlList.map((item, index) => (
              <Link key={`url-${index}`} target="_blank" href={item.href}>
                {item.fileName}
              </Link>
            ))}
          </Box>

          <Box className="buttonBox">
            <TkBackButton />
            <TkButton
              disabled={
                !(
                  Object.keys(fieldValue)?.length === 6 &&
                  Object.values(fieldValue)?.every(
                    (item) => item === "1" || item === true
                  )
                )
              }
              onClick={() => navigate("/SCRC060120")}
            >
              次へ
            </TkButton>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SCRC060119;
